/* src/context/FeedbackContext.jsx - Última MOdificación: 03-01-2026 */
/* showFeedback({                                                    */
/*  message: string;                                                 */
/*  severity?: 'success' | 'error' | 'warning' | 'info';             */
/* });                                                               */
/* ----------------------------------------------------------------- */

import { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const FeedbackContext = createContext(null);

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error('useFeedback debe usarse dentro de FeedbackProvider');
  }
  return context;
};

export function FeedbackProvider({ children }) {
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: 'success',
    message: '',
  });

  const showFeedback = ({ message, severity = 'success' }) => {
    setSnackbar({
      open: true,
      severity,
      message,
    });
  };

  return (
    <FeedbackContext.Provider value={{ showFeedback }}>
      {children}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() =>
          setSnackbar((prev) => ({ ...prev, open: false }))
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          sx={{
            bgcolor:
              snackbar.severity === 'success'
                ? '#1e293b'
                : '#7f1d1d',
            color: '#f8fafc',
            fontWeight: 500,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </FeedbackContext.Provider>
  );
}



// /* src/context/FeedbackContext.jsx - Última MOdificación: 03-01-2026 */
// /* showFeedback({                                                    */
// /*  message: string;                                                 */
// /*  severity?: 'success' | 'error' | 'warning' | 'info';             */
// /* });                                                               */
// /* ----------------------------------------------------------------- */

// import { createContext, useContext, useState } from 'react';
// import { Snackbar, Alert } from '@mui/material';

// const FeedbackContext = createContext(null);

// export const useFeedback = () => useContext(FeedbackContext);

// export function FeedbackProvider({ children }) {
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: 'success',
//     message: '',
//   });

//   const showFeedback = (message, severity = 'success') => {
//     setSnackbar({ open: true, severity, message });
//   };

//   return (
//     <FeedbackContext.Provider value={{ showFeedback }}>
//       {children}

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() =>
//           setSnackbar((prev) => ({ ...prev, open: false }))
//         }
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{
//             bgcolor:
//               snackbar.severity === 'success'
//                 ? '#1e293b'
//                 : '#7f1d1d',
//             color: '#f8fafc',
//             fontWeight: 500,
//           }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </FeedbackContext.Provider>
//   );
// };
